/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { Component } from 'react';
import {
    Route, Routes,
} from 'react-router-dom';

import ManagedIntegrationsContainer from "./ManagedIntegrationsContainer";
import CreateManagedIntegrationContainer from "./CreateManagedIntegrationContainer";
import ManagedIntegrationViewAsJSON from "./ManagedIntegrationViewAsJSON";

export default class ManagedIntegrationsRouter extends Component {
    static propTypes = {

    };

    static defaultProps = {

    };

    render() { // eslint-disable-line
        return (
            <Routes>
                <Route path="/create" element={<CreateManagedIntegrationContainer/>} />
                <Route path="/:id/view-as-json" element={<ManagedIntegrationViewAsJSON/>} />
                <Route path="/" element={<ManagedIntegrationsContainer/>} />
            </Routes>
        );
    }
}
